import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDutyScheme implements BaseEnumType {
  private static allValues: EnumDutyScheme[] = []; // make sure this is top-most
  
  public static none = new EnumDutyScheme(0, "None", "enum_duty_scheme_none");
  public static uk = new EnumDutyScheme(1, "Uk", "enum_duty_scheme_uk");
  public static germany = new EnumDutyScheme(2, "Germany", "enum_duty_scheme_germany");
  public static australia = new EnumDutyScheme(3, "Australia", "enum_duty_scheme_australia");
  public static southAfrica = new EnumDutyScheme(4, "SouthAfrica", "enum_duty_scheme_south_africa");
  public static sweden = new EnumDutyScheme(5, "Sweden", "enum_duty_scheme_sweden");
  public static us = new EnumDutyScheme(6, "Us", "enum_duty_scheme_us");
  public static eire = new EnumDutyScheme(7, "Eire", "enum_duty_scheme_eire");
  public static nz = new EnumDutyScheme(8, "Nz", "enum_duty_scheme_nz");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDutyScheme.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDutyScheme.none; }
  public isUk() { return this === EnumDutyScheme.uk; }
  public isGermany() { return this === EnumDutyScheme.germany; }
  public isAustralia() { return this === EnumDutyScheme.australia; }
  public isSouthAfrica() { return this === EnumDutyScheme.southAfrica; }
  public isSweden() { return this === EnumDutyScheme.sweden; }
  public isUs() { return this === EnumDutyScheme.us; }
  public isEire() { return this === EnumDutyScheme.eire; }
  public isNz() { return this === EnumDutyScheme.nz; }

  public static getValues(): readonly EnumDutyScheme[] {
    return EnumDutyScheme.allValues;
  }

  public static getValuesExcept0(): readonly EnumDutyScheme[] {
    return EnumDutyScheme.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDutyScheme {
    const found = EnumDutyScheme.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDutyScheme - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDutyScheme): EnumDutyScheme {
    const found = name ? EnumDutyScheme.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDutyScheme - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDutyScheme>): boolean {
    return this.key === other?.key;
  }
}